import { typeDef as CheckoutPage } from './schemas/checkoutPageSchema'
import { typeDef as CurrencyClient } from './schemas/currencyClientSchema'
import { typeDef as PriceClient } from './schemas/priceClientSchema'

export const typeDefs = [CheckoutPage, CurrencyClient, PriceClient]
